import React from 'react';
import TableTags from '../../../../shared/ui/TableTags';
import styles from '../index.module.scss';
import { formatDate } from '../../../../shared/packages/dateTime';

const Date = ({ date, time, ...props }) => {
  return (
    <TableTags {...props} withGap={false}>
      {Boolean(date) && <span className={styles.date}>{formatDate(date)}</span>}
      {Boolean(time) && <span className={styles.date}>{time}</span>}
    </TableTags>
  );
};

export default Date;
